import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { Entity, User } from '@apps/auth/domain/models/back';
import { CompareLowerString2 } from '@common/services';
import { BackConstants } from '@apps/back/back.constants';

export const UserExploitComparer = (ua: User, ub: User) =>
{
    const infoa = ua.email.toUpperCase();
    const infob = ub.email.toUpperCase();
    const xa: boolean = infoa.includes(BackConstants.ExploitAccount);
    const xb: boolean = infob.includes(BackConstants.ExploitAccount);

    if (xa)
    {
        if (xb)
        {
            return infoa.localeCompare(infob);
        }

        return -1;
    }
    else if (xb)
    {
        return 1;
    }
    else
    {
        return ua.firstLastName.toUpperCase().localeCompare(ub.firstLastName.toUpperCase());
    }
};
export type IUsersState = EntityState<User>;
export const usersAdapter: EntityAdapter<User> = createEntityAdapter<User>({
    selectId: (user: User) => user.id,
    sortComparer: CompareLowerString2<User>((user: User) => user.id)
});
export const usersInitialState: IUsersState = usersAdapter.getInitialState();

export class DetailedUser extends User
{
    entity: Entity;
}
